export const trailIfTooLong = (text?: string | null, maxLength = 30) => {
  if (!text) {
    return "";
  }
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};
